import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { type Cart, type CartProduct } from '@hungryroot/rest';
import {
  deleteProductFromBundle,
  type DeleteProductFromBundleMutationParams,
} from '@hungryroot/rest/api/v2/customers/[id]/cart/bundles/[bundle_id]/products/[product_id]/delete';
import { CartChangeType, executeRequestChangeHandlers } from '../useCartEvents';

interface DeleteCartProductParams
  extends UseMutationOptions<
    Cart,
    unknown,
    DeleteProductFromBundleMutationParams,
    { previousCart: Cart | null; product: CartProduct | null }
  > {}

export function useDeleteCartProductSelf(
  mutationOptions: DeleteCartProductParams
) {
  return useMutation<
    Cart,
    unknown,
    DeleteProductFromBundleMutationParams,
    { previousCart: Cart | null; product: CartProduct | null }
  >({
    mutationFn: async (params) => {
      executeRequestChangeHandlers({
        type: CartChangeType.RequestRemoveProduct,
      });
      const res = await deleteProductFromBundle(params);
      if (res.status !== 200) {
        throw res.data;
      }
      return res.data;
    },
    ...mutationOptions,
  });
}
